import api from './api';

export const listGradeSections = async (params = {}) => {
  const { data } = await api.get('/grade-sections', { params });
  return data;
};

export const getGradeSection = async (id) => {
  const { data } = await api.get(`/grade-sections/${id}`);
  return data;
};

export const createGradeSection = async (payload) => {
  const { data } = await api.post('/grade-sections', payload);
  return data;
};

export const updateGradeSection = async (id, payload) => {
  const { data } = await api.put(`/grade-sections/${id}`, payload);
  return data;
};

export const deleteGradeSection = async (id) => {
  const { data } = await api.delete(`/grade-sections/${id}`);
  return data;
};

export default {
  listGradeSections,
  getGradeSection,
  createGradeSection,
  updateGradeSection,
  deleteGradeSection,
};
